import * as types from '../../../lib/actionTypes.es6';

export const initialState = {


  getEmailTemplatesError: null,
  getEmailTemplatesloader: false,
  emailTemplates: [],
  isEmptyTemplates: false,

  addEmailTemplateError: null,
  addEmailTemplateLoader: false,
  addedEmailTemplate: null,

  updateEmailTemplateError: null,
  updateEmailTemplateLoader: false,
  updatedEmailTemplate: null,

  deleteEmailTemplateError: null,
  deleteEmailTemplateLoader: false,
  deleteEmailTemplate: null,
};

export default function emailTemplatesReducer(state = initialState, action) {
  switch (action.type) {


    case types.GET_EMAIL_TEMPLATES_REQUEST:
      return {
        ...state,
        getEmailTemplatesloader: true,
        getEmailTemplatesError: null,
        emailTemplates: [],
        isEmptyTemplates: false,
      };

    case types.GET_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        emailTemplates: action.payload,
        getEmailTemplatesloader: false,
        isEmptyTemplates: action.payload.length === 0
      };

    case types.GET_EMAIL_TEMPLATES_FAILURE:
      return {
        ...state,
        getEmailTemplatesloader: false,
        getEmailTemplatesError: action.payload,
        isEmptyTemplates: false,
      };

      case types.RESET_GET_EMAIL_TEMPLATES:
        return {
          ...state,
          getEmailTemplatesError: null,
          getEmailTemplatesloader: false,
          emailTemplates: [],
          isEmptyTemplates: false,
        };

    case types.ADD_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        addEmailTemplateLoader: true,
        addEmailTemplateError: null,
        addedEmailTemplate: null,
      };

    case types.ADD_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        addedEmailTemplate: action.payload,
        addEmailTemplateLoader: false,
      };

    case types.ADD_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        addEmailTemplateLoader: false,
        addEmailTemplateError: action.payload,
      };

    case types.RESET_ADD_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        addedEmailTemplate: null,
      };

    case types.RESET_ADD_EMAIL_TEMPLATE_ERROR:
      return {
        ...state,
        addEmailTemplateError: null,
      };

    case types.UPDATE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        updateEmailTemplateLoader: true,
        updateEmailTemplateError: null,
        updatedEmailTemplate: null,
      };

    case types.UPDATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        updateEmailTemplateLoader: false,
        updatedEmailTemplate: action.payload,
      };

    case types.UPDATE_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        updateEmailTemplateLoader: false,
        updateEmailTemplateError: action.payload,
      };

    case types.RESET_UPDATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        updatedEmailTemplate: null,
      };

    case types.RESET_UPDATE_EMAIL_TEMPLATE_ERROR:
      return {
        ...state,
        updateEmailTemplateError: null,
      };

    case types.DELETE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        deleteEmailTemplateLoader: true,
        deleteEmailTemplateError: null,
        deleteEmailTemplate: null,
      };

    case types.DELETE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteEmailTemplateLoader: false,
        deleteEmailTemplate: true,
      };

    case types.DELETE_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        deleteEmailTemplateLoader: false,
        deleteEmailTemplateError: action.payload,
      };

    case types.RESET_DELETE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteEmailTemplate: null,
      };

    case types.RESET_DELETE_EMAIL_TEMPLATE_ERROR:
      return {
        ...state,
        deleteEmailTemplateError: null,
      };

    default:
      return state;
  }
}
